import React from "react"
import STRINGS from "../globals/strings"
import IMAGES from "../globals/images"

function Summary({ summaryData, openPopup, openBatsmanPopup }) {

	return (

		<div className="summary">
			{summaryData ? (
				<>
					<div className="summary-card">
						<label className="player">{STRINGS.PLAYER_OF_MATCH}</label>
						<div className="player-details">
							<img src={summaryData.player_of_match?.profile_picture || IMAGES.KUNAL} alt={STRINGS.PLAYER_LOGO_ALT} className="player-logo" />
							<p style={{ textAlign: "left" }}>
								<label className="player-name">{summaryData.player_of_match?.name || "Unknown"}</label><br />
								<label className="player-team">{summaryData.player_of_match?.team_name || "Unknown Team"}</label>
							</p>
							<img src={IMAGES.TROPHY} alt={STRINGS.TROPHY_ALT} className="trophy-logo" />
						</div>
					</div>
					<div className="scorecard">
						<div className="scorecard-header">
							<a href="/#" className="scorecard-link">{STRINGS.BEST_PERFORMANCE}</a>
						</div>
						<table class="summary-best-performance-batsman">
							<thead>
								<tr>
									<th style={{ textAlign: "left" }}>{STRINGS.BATSMAN_HEADER}</th>
									<th style={{ textAlign: "right" }}>{STRINGS.RUNS_HEADER}</th>
									<th style={{ textAlign: "right" }}>{STRINGS.BALLS_HEADER}</th>
									<th style={{ textAlign: "right" }}>{STRINGS.FOURS_HEADER}</th>
									<th style={{ textAlign: "right" }}>{STRINGS.SIXES_HEADER}</th>
									<th style={{ textAlign: "right" }}>{STRINGS.STRIKE_RATE_HEADER}</th>
								</tr>
							</thead>
							<tbody>
								{summaryData.top_batsmen?.length > 0 ? (summaryData.top_batsmen.map((batsman, index) => (
									<tr key={index}>
										<td className="name" style={{ textAlign: "left", cursor: "pointer" }} onClick={() => openBatsmanPopup({ ...batsman, batsman_name: batsman.name })}>{batsman.name}<small style={{ fontSize: "16px", fontWeight: "500" }}>{batsman.team_name}</small></td>
										<td style={{ textAlign: "right", color: "#030311", fontSize: "16px", fontWeight: "500" }}>{batsman.total_runs}</td>
										<td style={{ textAlign: "right", color: "#030311", fontSize: "16px", fontWeight: "500" }}>{batsman.total_balls}</td>
										<td style={{ textAlign: "right", color: "#717171", fontSize: "16px", fontWeight: "500" }}>{batsman.total_fours}</td>
										<td style={{ textAlign: "right", color: "#717171", fontSize: "16px", fontWeight: "500" }}>{batsman.total_sixes}</td>
										<td style={{ textAlign: "right", color: "#717171", fontSize: "16px", fontWeight: "500" }}>{batsman.strike_rate?.toFixed(2)}</td>
									</tr>
								))) : (
									<tr>
										<td colSpan="6" className="batter-cell" style={{ textAlign: "center" }}>
											{STRINGS.NO_TOP_BATSMEN}
										</td>
									</tr>
								)}
							</tbody>
						</table>

						<table class="summary-best-performance-bowler" style={{ backgroundColor: "none" }}>
							<thead>
								<tr>
									<th style={{ textAlign: "left" }}>{STRINGS.BOWLER_HEADER}</th>
									<th style={{ textAlign: "right" }}>{STRINGS.OVERS_HEADER}</th>
									<th style={{ textAlign: "right" }}>{STRINGS.MAIDENS_HEADER}</th>
									<th style={{ textAlign: "right" }}>{STRINGS.RUNS_HEADER}</th>
									<th style={{ textAlign: "right" }}>{STRINGS.WICKETS_HEADER}</th>
									<th style={{ textAlign: "right" }}>{STRINGS.ECONOMY_HEADER}</th>
								</tr>
							</thead>
							<tbody>
								{summaryData.top_bowlers?.length > 0 ? (summaryData.top_bowlers.map((bowler, index) => (
									<tr key={index}>
										<td class="name" style={{ textAlign: "left", cursor: "pointer" }} onClick={() => openPopup(bowler, 1, summaryData.teams[0].team_name === bowler.team_name
											? summaryData.teams[1].team_name
											: summaryData.teams[0].team_name)}>{bowler.bowler_name}<img src={IMAGES.VECTOR2} alt={STRINGS.BOWLER_DROPDOWN_ALT} className="bowler-dropdown" onClick={() => openPopup(bowler, 1)} /><small style={{ fontSize: "16px", fontWeight: "500" }}>{bowler.team_name}</small></td>
										<td style={{ textAlign: "right", color: "#030311", fontSize: "16px", fontWeight: "500" }}>{bowler.total_over}</td>
										<td style={{ textAlign: "right", color: "#717171", fontSize: "16px", fontWeight: "500" }}>{bowler.total_maiden_over}</td>
										<td style={{ textAlign: "right", color: "#717171", fontSize: "16px", fontWeight: "500" }}>{bowler.total_run}</td>
										<td style={{ textAlign: "right", color: "#030311", fontSize: "16px", fontWeight: "500" }}>{bowler.total_wicket}</td>
										<td style={{ textAlign: "right", color: "#717171", fontSize: "16px", fontWeight: "500" }}>{bowler.economy?.toFixed(2)}</td>
									</tr>
								))) : (
									<tr>
										<td colSpan="6" className="batter-cell" style={{ textAlign: "center" }}>
											{STRINGS.NO_TOP_BOWLERS}
										</td>
									</tr>
								)}
							</tbody>
						</table>
					</div>
				</>
			) : (
				<div style={{ textAlign: "center", fontSize: "16px", color: "#3747DE", fontWeight: "700", padding: "20px" }}>
					{STRINGS.NO_SUMMARY_DATA}
				</div>
			)}
		</div>
	)
}

export default Summary